// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoAccessView_wrapper__3L25p"};